import { render, staticRenderFns } from "./OptionsButtons.vue?vue&type=template&id=32cae04e&scoped=true&"
import script from "./OptionsButtons.vue?vue&type=script&lang=js&"
export * from "./OptionsButtons.vue?vue&type=script&lang=js&"
import style0 from "./OptionsButtons.vue?vue&type=style&index=0&id=32cae04e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cae04e",
  null
  
)

export default component.exports